module.exports = __webpack_public_path__ + "static/media/icon-email.88247382.svg";